import React from 'react';
import styled from '@emotion/styled';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background: #f8f9fa;
`;

const Spinner = styled.div`
  width: 48px;
  height: 48px;
  border: 4px solid #e1e8ed;
  border-top: 4px solid #002677;
  border-radius: 50%;
  animation: spin 1s linear infinite;

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

const Message = styled.p`
  margin-top: 16px;
  font-size: 16px;
  color: #5a6c7d;
  font-weight: 500;
`;

export const LoadingPage: React.FC = () => {
  return (
    <Container>
      <Spinner />
      <Message>Authenticating...</Message>
    </Container>
  );
};

export default LoadingPage;
